









import { Component, Prop, Mixins } from "vue-property-decorator";
import { isString } from "lodash";

// Mixins
import { WidgetMixin, TextMixin } from "./mixins";

// TODO: Fix widget to not be hacky
@Component
export default class WAlert extends Mixins(WidgetMixin, TextMixin) {
  @Prop({ type: String, default: "success" })
  variant!: string;

  @Prop({ type: [String, Boolean], default: true })
  show!: string | boolean;

  get computedShow() {
    let show = this.show;
    if (isString(show)) {
      show = this.getVariable(show);
    }
    return !!show;
  }
}
